var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLocalOffer(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 56,
    viewBox: "0 0 57 56",
    fill: "#FEB53E",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.458 27.0203L29.458 6.02033C28.618 5.18033 27.4513 4.66699 26.168 4.66699H9.83464C7.26797 4.66699 5.16797 6.76699 5.16797 9.33366V25.667C5.16797 26.9503 5.6813 28.117 6.54464 28.9803L27.5446 49.9803C28.3846 50.8203 29.5513 51.3337 30.8346 51.3337C32.118 51.3337 33.2846 50.8203 34.1246 49.957L50.458 33.6237C51.3213 32.7837 51.8346 31.617 51.8346 30.3337C51.8346 29.0503 51.298 27.8603 50.458 27.0203ZM30.8345 46.6903L9.83451 25.667V9.33365H26.1678V9.31031L47.1678 30.3103L30.8345 46.6903ZM12.168 15.167C12.168 13.234 13.735 11.667 15.668 11.667C17.601 11.667 19.168 13.234 19.168 15.167C19.168 17.1 17.601 18.667 15.668 18.667C13.735 18.667 12.168 17.1 12.168 15.167Z",
    fill: "inherit"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocalOffer);
export default __webpack_public_path__ + "static/media/local_offer.bc5db6a8e12f5255fcee5b61fc9a96b8.svg";
export { ForwardRef as ReactComponent };